import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MarketingNavbar from "./MarketingNavbar";
import Footer from "./Footer";
import "./marketing.css";

export default function MarketingLayout({ children, onLoginClick, onBookDemoClick, className = "" }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className={`mk-shell${className ? ` ${className}` : ""}`}>
      <MarketingNavbar onLoginClick={onLoginClick} onBookDemoClick={onBookDemoClick} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
